import { currentUser } from "@/App";
import { setCurrentUser } from "@/utils";

const API_BASE = process.env.REACT_APP_API_BASE;
const AUDIOSAFE_API_BASE = process.env.REACT_APP_AUDIOSAFE_API_BASE;

const headers = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
};

export const fetchAudioSafeUrl = async (contentKey) => {
  const params = new URLSearchParams({
    user_key: currentUser.key,
    content_key: contentKey,
  });
  const endpoint = `${AUDIOSAFE_API_BASE}/audiosafe-url?${params}`;
  const response = await fetch(endpoint);
  if (!response.ok) {
    throw new Error(`Failed to load audio URL (${response.status})`);
  }
  const data = await response.json();
  if (!data?.public_url) {
    throw new Error("Failed to load audio URL (missing public_url)");
  }
  return data.public_url;
};

export const postAiSummary = async (prompt) => {
  const endpoint = new URL(API_BASE + "/ai-summary");
  const response = await fetch(endpoint.toString(), {
    ...headers,
    method: "POST",
    body: JSON.stringify({ prompt, artist_key: currentUser.key }),
  });
  return response.json();
};
export const fetchCurrentUser = async () => {
  if (window.location.pathname.includes("/blocked")) {
    return;
  }

  try {
    const endpoint = new URL(API_BASE + "/user");
    endpoint.searchParams.append("key", currentUser.key);
    const response = await fetch(endpoint.toString(), { ...headers });
    const user = await response.json();

    setCurrentUser(user);
    if (user.blocked == true) {
      window.location.href = "/blocked";
    }
    return user;
  } catch (error) {
    console.log(error);
    window.location.href = "/logout";
  }
};

export const fetchArtist = async (artistKey) => {
  const endpoint = new URL(API_BASE + "/artist");
  endpoint.searchParams.append("artist_key", artistKey);
  try {
    const response = await fetch(endpoint.toString(), { ...headers });
    if (!response.ok) {
      console.log(response);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    console.log(error);
    // throw new Error(`HTTP error! status: ${response.status}`);
    window.location.href = "/";
  }
  return response.json();
};

export const fetchFeatured = async (artistKey) => {
  const endpoint = new URL(API_BASE + "/featured");
  endpoint.searchParams.append("artist_key", artistKey);
  endpoint.searchParams.append("user_key", currentUser.key);

  const response = await fetch(endpoint.toString(), { ...headers });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchContent = async (artistKey, contentTypes) => {
  const endpoint = new URL(API_BASE + "/content");
  endpoint.searchParams.append("artist_key", artistKey);
  endpoint.searchParams.append("user_key", currentUser.key);
  endpoint.searchParams.append("content_types", contentTypes);

  const response = await fetch(endpoint.toString(), { ...headers });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchMusic = async (artistKey) => {
  const endpoint = new URL(API_BASE + "/music");
  endpoint.searchParams.append("artist_key", artistKey);
  endpoint.searchParams.append("user_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const createCheckout = async (artistKey) => {
  const endpoint = new URL(API_BASE + "/checkout");
  endpoint.searchParams.append("artist_key", artistKey);
  endpoint.searchParams.append("user_key", currentUser.key);
  endpoint.searchParams.append("country", localStorage.getItem("country"));
  endpoint.searchParams.append("limited", localStorage.getItem("limited"));
  endpoint.searchParams.append("code", localStorage.getItem("code"));

  const response = await fetch(endpoint.toString(), { ...headers });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchActiveArtists = async () => {
  const endpoint = new URL(API_BASE + "/active_artists");
  endpoint.searchParams.append("user_key", currentUser.key);

  const response = await fetch(endpoint.toString(), { ...headers });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchSubscriptions = async () => {
  const endpoint = new URL(API_BASE + "/subscriptions");
  endpoint.searchParams.append("user_key", currentUser.key);

  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const fetchDiscover = async () => {
  const endpoint = new URL(API_BASE + "/discover");
  endpoint.searchParams.append("user_key", currentUser.key);

  const response = await fetch(endpoint.toString(), { ...headers });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const createThread = async (owner_key, artist_key, title, text) => {
  const endpoint = API_BASE + "/thread";
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({
      owner_key,
      artist_key,
      type: "thread",
      meta: {
        title,
        text,
      },
    }),
  });
  return response.json();
};

export const fetchArtists = async () => {
  const endpoint = new URL(API_BASE + "/artists");
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const updateUser = async (name, meta) => {
  const endpoint = new URL(API_BASE + "/user/update");
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({
      name,
      key: currentUser.key,
      meta,
    }),
  });
  return response.json();
};

export const fetchSong = async (songKey) => {
  const endpoint = new URL(API_BASE + "/song");
  endpoint.searchParams.append("key", songKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const fetchCapacity = async (artistKey) => {
  const endpoint = new URL(API_BASE + "/capacity");
  endpoint.searchParams.append("artist_key", artistKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const fetchInvites = async (artistKey) => {
  const endpoint = new URL(API_BASE + "/invites");
  endpoint.searchParams.append("artist_key", artistKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchLocation = async () => {
  const endpoint = new URL(API_BASE + "/location");
  endpoint.searchParams.append("user_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { ...headers });
  const data = await response.json();
  // set the country in local storage
  localStorage.setItem("country", data.country);
  localStorage.setItem("limited", data.limited);
  localStorage.setItem("loc", data.loc);
  // notify listeners (e.g. SubscribedProvider) that country/limited resolved,
  // so gated UI updates without requiring a manual page reload
  window.dispatchEvent(new Event("location-updated"));
  return data;
};

export const fetchPollResults = async (contentKey) => {
  const endpoint = new URL(API_BASE + "/poll_results");
  endpoint.searchParams.append("content_key", contentKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const postEvent = async (type, contentKey, data) => {
  const endpoint = new URL(API_BASE + "/event");
  const body = {
    user_key: currentUser.key,
    content_key: contentKey,
    type,
  };
  if (data) {
    body.data = data;
  }
  const response = await fetch(endpoint.toString(), {
    ...headers,
    method: "POST",
    body: JSON.stringify(body),
  });
  return response.json();
};

export const postVote = async (contentKey, option) => {
  console.log("postVote", contentKey, option);
  const endpoint = new URL(API_BASE + "/event");
  const data = {
    user_key: currentUser.key,
    content_key: contentKey,
    type: "vote",
    data: { text: option },
  };

  const response = await fetch(endpoint.toString(), {
    ...headers,
    method: "POST",
    body: JSON.stringify(data),
  });
  return response.json();
};

export const fetchIdeas = async () => {
  const endpoint = new URL(API_BASE + "/ideas");
  endpoint.searchParams.append("user_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { ...headers });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchScheduled = async () => {
  const endpoint = new URL(API_BASE + "/scheduled");
  endpoint.searchParams.append("user_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const fetchStripeBillingPortal = async (stripeId) => {
  const endpoint = new URL(API_BASE + "/stripe-billing-portal");
  endpoint.searchParams.append("stripe_id", stripeId);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const toggleFavorite = async (content) => {
  const endpoint = API_BASE + "/favorite";
  const method = content.user_favorite ? "DELETE" : "POST";

  const response = await fetch(endpoint, {
    ...headers,
    method,
    body: JSON.stringify({
      content_key: content.key,
      user_key: currentUser.key,
    }),
  });
  return response.json();
};

export const toggleCommentFavorite = async (event) => {
  const endpoint = new URL(API_BASE + "/event");
  const response = await fetch(endpoint.toString(), {
    ...headers,
    method: "POST",
    body: JSON.stringify({
      user_key: currentUser.key,
      content_key: event.content_key,
      parent_id: event.id,
      type: event.user_favorite ? "unfavorite" : "favorite",
    }),
  });
  return response.json();
};

export const toggleFeatured = async (content) => {
  const endpoint = new URL(API_BASE + "/content/featured");

  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({
      content_key: content.key,
      user_key: currentUser.key,
    }),
  });
  return response.json();
};

export const removeContent = async (content) => {
  const endpoint = new URL(API_BASE + "/content/remove");
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({
      content_key: content.key,
      user_key: currentUser.key,
    }),
  });
};

export const updateContent = async (content) => {
  const endpoint = new URL(API_BASE + "/content/update");
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({
      content_key: content.key,
      user_key: currentUser.key,
      meta: content.meta,
    }),
  });
  return response.json();
};

export const toggleRSVP = async (content) => {
  const endpoint = API_BASE + "/experience/rsvp";
  const method = content.user_rsvp ? "DELETE" : "POST";

  const response = await fetch(endpoint, {
    ...headers,
    method,
    body: JSON.stringify({
      content_key: content.key,
      user_key: currentUser.key,
    }),
  });
  return response.json();
};

export const fetchExperience = async (key) => {
  const endpoint = new URL(API_BASE + "/experience");
  endpoint.searchParams.append("key", key);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};



export const fetchExperienceRSVPs = async (key) => {
  const endpoint = new URL(API_BASE + "/experience/rsvps");
  endpoint.searchParams.append("key", key);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const checkInUser = async (experienceKey, userKey) => {
  const endpoint = new URL(API_BASE + "/experience/checkin");
  endpoint.searchParams.append("experience_key", experienceKey);
  endpoint.searchParams.append("user_key", userKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const blockUser = async (userKey) => {
  const endpoint = new URL(API_BASE + "/user/block");
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({ user_key: userKey, blocker_key: currentUser.key }),
  });
  return response.json();
};

export const fetchUser = async (userKey) => {
  const endpoint = new URL(API_BASE + "/user");
  endpoint.searchParams.append("key", userKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const fetchUserComments = async (userKey) => {
  const endpoint = new URL(API_BASE + "/user/comments");
  endpoint.searchParams.append("key", userKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const fetchMutedComments = async (artistKey) => {
  const endpoint = new URL(API_BASE + "/artist/muted-comments");
  endpoint.searchParams.append("artist_key", artistKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const fetchComments = async (contentKey) => {
  const endpoint = new URL(API_BASE + "/comments");
  endpoint.searchParams.append("content_key", contentKey);
  endpoint.searchParams.append("user_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const postComment = async (contentKey, text, currentTime) => {
  const endpoint = new URL(API_BASE + "/event");
  const data = {
    content_key: contentKey,
    user_key: currentUser.key,
    type: "comment",
    data: { text },
  };
  if (currentTime && currentTime > 0) {
    data.data.current_time = currentTime;
  }
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify(data),
  });
  return response.json();
};

export const postReply = async (contentKey, text, parentId) => {
  const endpoint = new URL(API_BASE + "/event");
  const data = {
    content_key: contentKey,
    user_key: currentUser.key,
    type: "comment",
    parent_id: parentId,
    data: { text },
  };
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify(data),
  });
  return response.json();
};

export const deleteComment = async (commentId) => {
  const endpoint = new URL(API_BASE + "/comment/delete");
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({ id: commentId, user_key: currentUser.key }),
  });
  return response.json();
};

export const fetchBroadcast = async (key) => {
  const endpoint = new URL(API_BASE + "/broadcast");
  endpoint.searchParams.append("key", key);
  endpoint.searchParams.append("user_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

const formDataAuthHeaders = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
};

export const createLiveBroadcast = async (text) => {
  const formData = new FormData();
  formData.append("owner_key", currentUser.key);
  formData.append("artist_key", currentUser.key);
  formData.append("type", "live");
  formData.append("meta", JSON.stringify({ text }));

  const response = await fetch(`${API_BASE}/broadcast`, {
    ...formDataAuthHeaders,
    method: "POST",
    body: formData,
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const postBroadcastStart = async () => {
  const endpoint = new URL(API_BASE + "/broadcast/start");
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({ user_key: currentUser.key }),
  });
  return response.json();
};

export const postBroadcastStop = async (key) => {
  const endpoint = new URL(API_BASE + "/broadcast/stop");
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({ key }),
  });
  return response.json();
};

export const fetchUserSummary = async (userKey) => {
  const endpoint = new URL(API_BASE + "/user/summary");
  endpoint.searchParams.append("key", userKey);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const fetchAccounts = async () => {
  const endpoint = new URL(API_BASE + "/manager");
  endpoint.searchParams.append("user_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { ...headers });
  return response.json();
};

export const removeAccountManager = async (userKey) => {
  const endpoint = new URL(API_BASE + "/manager");
  const response = await fetch(endpoint.toString(), {
    ...headers,
    method: "DELETE",
    body: JSON.stringify({
      artist_key: currentUser.key,
      user_key: userKey,
    }),
  });
  return response.json();
};

export const addAccountManager = async (phone) => {
  const endpoint = new URL(API_BASE + "/manager");
  const response = await fetch(endpoint.toString(), {
    ...headers,
    method: "POST",
    body: JSON.stringify({
      artist_key: currentUser.key,
      phone,
    }),
  });
  return response.json();
};

export const createArtist = async (key) => {
  // assert currentUser.admin is true
  if (!currentUser.admin) {
    throw new Error("You are not authorized to create an artist");
  }

  const endpoint = new URL(API_BASE + "/artist/create");
  const response = await fetch(endpoint, {
    ...headers,
    method: "POST",
    body: JSON.stringify({ key }),
  });
  return response.json();
};
